<script setup lang="ts">
import { computed } from 'vue';
import { Languages } from '@lucide/vue';
import { locale, setLocale, t } from '@/i18n';
defineProps<{ onBrand?: boolean }>();
const label = computed(() => t('common.switchLanguage', {
  current: locale.value.toUpperCase(),
  language: locale.value === 'es' ? 'English' : 'Español',
}));
function toggle() { setLocale(locale.value === 'es' ? 'en' : 'es'); }
</script>
<template>
  <button type="button" class="language-selector" :class="{ 'on-brand': onBrand }" :title="label" :aria-label="label" @click="toggle">
    <Languages aria-hidden="true"/>
    <span class="language-code">{{ locale.toUpperCase() }}</span>
  </button>
</template>
<style scoped>
.language-selector{display:flex;align-items:center;justify-content:center;gap:8px;flex:none;width:76px;height:44px;min-height:44px;padding:0 10px;border:1px solid var(--input-border);border-radius:9px;color:var(--ink);background:var(--surface);margin-left:auto;cursor:pointer;transition:background-color 140ms,border-color 140ms,transform 140ms}
.language-selector>svg{width:18px;height:18px;stroke-width:1.8;pointer-events:none}
.language-code{font-size:12px;font-weight:650;letter-spacing:.4px}
.language-selector:hover{background:var(--surface-hover);border-color:var(--primary);color:var(--primary)}
.language-selector:focus-visible{outline:2px solid var(--focus);outline-offset:3px}
.language-selector:active{transform:scale(.96)}
.language-selector.on-brand{background:transparent;color:var(--header-text);border-color:color-mix(in srgb,var(--header-text) 32%,transparent)}
.language-selector.on-brand:hover{background:color-mix(in srgb,var(--header-text) 12%,transparent);border-color:color-mix(in srgb,var(--header-text) 60%,transparent)}
.language-selector.on-brand:focus-visible{outline-color:var(--header-text)}
@media(max-width:520px){.language-selector{width:58px;gap:5px;padding-inline:6px}.language-selector>svg{width:15px;height:15px}}
@media(prefers-reduced-motion:reduce){.language-selector{transition:none}.language-selector:active{transform:none}}
@media(forced-colors:active){.language-selector,.language-selector.on-brand{color:ButtonText;border-color:ButtonText}}
</style>
